var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { mergeQueryString } from 'bernie-core';
import { parse } from 'query-string';
export var SortAndFiltersCustomEventTypes;
(function (SortAndFiltersCustomEventTypes) {
  SortAndFiltersCustomEventTypes["CLEAR"] = "clear";
  SortAndFiltersCustomEventTypes["RESTORE"] = "restore";
})(SortAndFiltersCustomEventTypes || (SortAndFiltersCustomEventTypes = {}));
export var SortAndFiltersRangeParamKey;
(function (SortAndFiltersRangeParamKey) {
  SortAndFiltersRangeParamKey["PRICE"] = "price";
  SortAndFiltersRangeParamKey["NIGHTLY_PRICE"] = "nightly_price";
  SortAndFiltersRangeParamKey["TOTAL_PRICE"] = "total_price";
})(SortAndFiltersRangeParamKey || (SortAndFiltersRangeParamKey = {}));
export var SortAndFiltersParamsKeys;
(function (SortAndFiltersParamsKeys) {
  SortAndFiltersParamsKeys["SORT"] = "sort";
  SortAndFiltersParamsKeys["HOTEL_NAME"] = "hotelName";
  SortAndFiltersParamsKeys["REWARDS"] = "rewards";
  SortAndFiltersParamsKeys["STAR"] = "star";
  SortAndFiltersParamsKeys["GUEST_RATING"] = "guestRating";
  SortAndFiltersParamsKeys["CLEANING_AND_SAFETY"] = "cleaningAndSafetyPractices";
  SortAndFiltersParamsKeys["LODGING"] = "lodging";
  SortAndFiltersParamsKeys["MEAL_PLAN"] = "mealPlan";
  SortAndFiltersParamsKeys["AMENITIES"] = "amenities";
  SortAndFiltersParamsKeys["TRAVELER_TYPE"] = "travelerType";
  SortAndFiltersParamsKeys["PAYMENT_TYPE"] = "paymentType";
  SortAndFiltersParamsKeys["DEALS"] = "deals";
  SortAndFiltersParamsKeys["PROPERTY_STYLE"] = "propertyStyle";
  SortAndFiltersParamsKeys["BEDROOM_FILTER"] = "bedroomFilter";
  SortAndFiltersParamsKeys["NEIGHBORHOOD"] = "neighborhood";
  SortAndFiltersParamsKeys["STAY_TYPE"] = "stayType";
  SortAndFiltersParamsKeys["ACCESSIBILITY"] = "accessibility";
  SortAndFiltersParamsKeys["POI"] = "poi";
  SortAndFiltersParamsKeys["MIN_BEDROOMS"] = "bedroom_count_gt";
  SortAndFiltersParamsKeys["MIN_BATHROOMS"] = "us_bathroom_count_gt";
  SortAndFiltersParamsKeys["PROPERTY_TYPE"] = "property_type_group";
  SortAndFiltersParamsKeys["LOCATION"] = "location_group";
  SortAndFiltersParamsKeys["ACCESSIBILITY_FEATURES"] = "accessibility_features_group";
  SortAndFiltersParamsKeys["BOOKING_OPTIONS"] = "booking_options_group";
  SortAndFiltersParamsKeys["DISCOUNTS_GROUP"] = "discounts_group";
  SortAndFiltersParamsKeys["AMENITIES_FACILITIES"] = "amenities_facilities_group";
  SortAndFiltersParamsKeys["FREE_CANCELLATION_GROUP"] = "free_cancellation_group";
  SortAndFiltersParamsKeys["HOUSE_RULES"] = "house_rules_group";
  SortAndFiltersParamsKeys["NEARBY_ACTIVITIES"] = "nearby_activities_group";
  SortAndFiltersParamsKeys["NEIGHBORHOOD_GROUP"] = "neighborhood_group";
  SortAndFiltersParamsKeys["PREMIER_HOST"] = "premier_host_group";
  SortAndFiltersParamsKeys["PROPERTIES_GOOD"] = "properties_good_for_group";
  SortAndFiltersParamsKeys["PROPERTY_REVIEWS"] = "property_reviews_group";
  SortAndFiltersParamsKeys["ROOMS_SPACES"] = "rooms_spaces_group";
  SortAndFiltersParamsKeys["SAFETY"] = "safety_group";
  SortAndFiltersParamsKeys["VIRTUAL_TOUR_GROUP"] = "virtual_tour_group";
  SortAndFiltersParamsKeys["PRICING_GROUP"] = "pricing_group";
  SortAndFiltersParamsKeys["PROPERTY_NAME"] = "propertyName";
  SortAndFiltersParamsKeys["AVAILABLE_FILTER"] = "availableFilter";
  SortAndFiltersParamsKeys["AGENCY_BUSINESS_MODELS"] = "agencyBusinessModels";
  SortAndFiltersParamsKeys["COMMISSION_TIERS"] = "commissionTiers";
})(SortAndFiltersParamsKeys || (SortAndFiltersParamsKeys = {}));
var FILTER_URL_PARAM_PREFIX = 'filter.';
var ACTIVITY_TEXT_INPUT_KEYWORD = 'slimSearchKeyword';
var ACTIVITY_SORT_URL = 'sort';
var SWP = 'swp';
var keepNonUniversalSortFilterKeys = function (key) {
  var shouldKeepFilter = !key.startsWith(FILTER_URL_PARAM_PREFIX) || !key;
  return shouldKeepFilter;
};
export var getUpdatedFilterQueryObject = function (queryParams) {
  var filterQueryParams = __spreadArray([], __read(queryParams), false).filter(function (_a) {
    var _b = __read(_a, 1),
      key = _b[0];
    return key.startsWith(FILTER_URL_PARAM_PREFIX) || key === ACTIVITY_TEXT_INPUT_KEYWORD;
  });
  var filterSelections = filterQueryParams.map(function (_a) {
    var _b = __read(_a, 2),
      key = _b[0],
      value = _b[1];
    return {
      id: key === ACTIVITY_TEXT_INPUT_KEYWORD ? ACTIVITY_TEXT_INPUT_KEYWORD : key.substring(FILTER_URL_PARAM_PREFIX.length),
      value: value.split(',')
    };
  }).flatMap(function (_a) {
    var id = _a.id,
      value = _a.value;
    return value.map(function (val) {
      return {
        id: id,
        value: val
      };
    });
  });
  return {
    selections: filterSelections
  };
};
export var getUpdatedFilterQueryObjectForPDP = function (queryParams) {
  var filterQueryParams = __spreadArray([], __read(queryParams), false).filter(function (_a) {
    var _b = __read(_a, 1),
      key = _b[0];
    return key.startsWith(FILTER_URL_PARAM_PREFIX) || key === ACTIVITY_TEXT_INPUT_KEYWORD || key === ACTIVITY_SORT_URL || key === SWP;
  });
  if (filterQueryParams.length === 0) {
    return null; // Return null if no filter selections are found
  }
  var filterSelections = filterQueryParams.flatMap(function (_a) {
    var _b = __read(_a, 2),
      key = _b[0],
      value = _b[1];
    var id = '';
    switch (key) {
      case ACTIVITY_TEXT_INPUT_KEYWORD:
        id = ACTIVITY_TEXT_INPUT_KEYWORD;
        break;
      case ACTIVITY_SORT_URL:
        id = ACTIVITY_SORT_URL;
        break;
      case SWP:
        id = SWP;
        break;
      default:
        if (key.startsWith(FILTER_URL_PARAM_PREFIX)) {
          id = key.substring(FILTER_URL_PARAM_PREFIX.length);
        }
    }
    var values = value.split(',');
    return values.map(function (val) {
      return {
        id: id,
        value: val
      };
    });
  });
  return {
    selections: filterSelections
  };
};
export var buildUrlQueryString = function (_a) {
  var _b, _c, _d;
  var name = _a.name,
    value = _a.value,
    existingUrlQueryString = _a.existingUrlQueryString,
    eventTargetType = _a.eventTargetType;
  var newUrlQueryString;
  var newUrlQueryParameters;
  var parsedUrlQueryString = parse(existingUrlQueryString);
  var paramName = "filter.".concat(name);
  switch (name) {
    case SortAndFiltersCustomEventTypes.CLEAR:
      // Take the existing query string and filter out USF filters.
      // Merge the resulting query string with an empty object (to preserve other filters).
      return mergeQueryString(existingUrlQueryString, {}, keepNonUniversalSortFilterKeys);
    case SortAndFiltersCustomEventTypes.RESTORE:
      // Return an empty string to indicate that the filter has been reset.
      return '';
    default:
      {
        if (eventTargetType === 'checkbox') {
          if (parsedUrlQueryString[paramName] && parsedUrlQueryString[paramName].includes(value)) {
            parsedUrlQueryString[paramName] = parsedUrlQueryString[paramName].split(',');
            parsedUrlQueryString[paramName] = Array.isArray(parsedUrlQueryString[paramName]) ? parsedUrlQueryString[paramName].filter(function (current) {
              return current !== value;
            }) : [];
            newUrlQueryParameters = (_b = {}, _b[paramName] = parsedUrlQueryString[paramName], _b);
            newUrlQueryString = mergeQueryString(existingUrlQueryString, newUrlQueryParameters);
            return newUrlQueryString;
          }
          Object.prototype.hasOwnProperty.call(parsedUrlQueryString, paramName) ? parsedUrlQueryString[paramName] = [parsedUrlQueryString[paramName], value] : parsedUrlQueryString[paramName] = [value];
          parsedUrlQueryString[paramName] = parsedUrlQueryString[paramName].join(',');
          newUrlQueryString = mergeQueryString(existingUrlQueryString, parsedUrlQueryString);
          return newUrlQueryString;
        }
        if (eventTargetType === 'text') {
          newUrlQueryParameters = (_c = {}, _c[name] = value, _c);
          newUrlQueryString = mergeQueryString(existingUrlQueryString, newUrlQueryParameters);
          return newUrlQueryString;
        }
        // For all other inputs, add the "name" and "value" to the query string.
        newUrlQueryParameters = (_d = {}, _d[paramName] = value, _d);
        newUrlQueryString = mergeQueryString(existingUrlQueryString, newUrlQueryParameters);
        return newUrlQueryString;
      }
  }
};